// extracted by mini-css-extract-plugin
export default {"NewsContainer":"News_NewsContainer__z9vpk","FirstArticle":"News_FirstArticle__2s+Zo","OtherArticles":"News_OtherArticles__xhTp3","NewsListContainer":"News_NewsListContainer__KeTsL"};